export default __webpack_public_path__ + "static/form-default-values-do-97b43a1d4473a72016928f9afdcee6ac6989006841c8ea298caa9fcf0ae67002.png";